var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"mt-2 mb-2",attrs:{"cols":"12","md":"12"}},[_c('DonutChart',{attrs:{"title_header":'Ordenes de compra ',"data":_vm.orders}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }